















import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';

@Component({
  name: 'BookingRoleWorkerShift',
  components: { BookingRoleWorkerShiftStatus, ShiftStatus },
})
export default class extends GiganautVue {

	@Prop({required: true})
	bookingRoleWorkerShifts: BookingRoleWorkerShiftDto[];

}
